import React from "react";
import { withStyles } from "tss-react/mui";
import BoltIcon from "@mui/icons-material/Bolt";
import PropTypes from "prop-types";
import Point from "../../interfaces/robot/rooms/point";

interface StationSvgProps extends Point {
  isSecondaryStation?: boolean;
}

const ChargingStationIcon = withStyles(BoltIcon, {
  root: {
    filter: "drop-shadow(0 0 1px #000000)",
    color: "#FFC400",
  },
});

const arePropsEqual = (prevProps: StationSvgProps, nextProps: StationSvgProps) => {
  return (
    prevProps.coordinateX === nextProps.coordinateX &&
    prevProps.coordinateY === nextProps.coordinateY &&
    prevProps.isSecondaryStation === nextProps.isSecondaryStation
  );
};

const StationSvgComponent: React.FC<StationSvgProps> = React.memo(
  ({ coordinateX, coordinateY, isSecondaryStation }) => {
    return (
      <g transform={`translate(${coordinateX - 12}, ${coordinateY - 12})`} opacity={isSecondaryStation ? 0.5 : 1}>
        <ChargingStationIcon inheritViewBox />
      </g>
    );
  },
  arePropsEqual
);

StationSvgComponent.displayName = "StationSvg";
StationSvgComponent.propTypes = {
  coordinateX: PropTypes.number.isRequired,
  coordinateY: PropTypes.number.isRequired,
  isSecondaryStation: PropTypes.bool,
};

const StationSvg = React.memo(StationSvgComponent);

export default StationSvg;
